import axios from "axios";
import { t } from "i18next";

import AlertsService from "services/alerts-service";

const FilesApi = {
    uploadFile: async (data: any) => {
        try {
            const formData = new FormData();
            formData.append("file", data);
            const { data: response } = (await axios.post("/file/upload", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            })) as any;
            return response;
        } catch (error) {
            throw AlertsService.showError(t('qt791m9fsvk'));
        }
    },
};

export default FilesApi;
